const getPureBusinessNumber = (v) => {
    var regex = /[^0-9]/g;			
    var value = v.replace(regex, "");	
    return value;
}
export default getPureBusinessNumber